import { auth, db, storage } from "./firebaseConfig";
import * as firebase_auth from "firebase/auth";
import * as firebase_firestore from "firebase/firestore";
import * as firebase_storage from "firebase/storage";

export const firebaseFirestore = firebase_firestore;
export const firebaseAuth = firebase_auth;
export const firebaseStorage = firebase_storage;
export const firebase = { auth, db, storage }

const generateRandomString = () => {
  const result = Math.random().toString(36).substring(2, 8);
  return result.toUpperCase();
};

export async function signin(email, password) {
  try {
    let res = await firebase_auth.signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    if (!res.user.emailVerified) {
      await firebase_auth.signOut(auth);
      await firebase_auth.sendEmailVerification(res.user);
      throw new Error("Email not verified");
    }
    await firebase_auth.setPersistence(auth, firebase_auth.browserLocalPersistence);
    return res;
  } catch (error) {
    return error;
  }
}

export async function signup(email, password, name, referralCode, phoneNumber) {
  try {
    let res = await firebase_auth.createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    await firebase_auth.setPersistence(auth, firebase_auth.browserLocalPersistence);
    const ref = generateRandomString();
    await firebase_auth.updateProfile(res.user, { displayName: name });
    await firebase_auth.sendEmailVerification(res.user);
    const userRef = firebaseFirestore.doc(db, "users", res?.user?.email);
    await firebaseFirestore.setDoc(userRef, {
      name: name,
      email: email,
      phoneNumber,
      referralCode: ref,
      referralCount: 0,
      referralList: [],
    });
    // if (referralCode) {
    //   const query = firebaseFirestore.query(
    //     firebaseFirestore.collection(db, "users"),
    //     firebaseFirestore.where("referralCode", "==", referralCode),
    //     firebaseFirestore.where("referralCount", "<", 3)
    //   );
    //   const querySnapshot = await firebaseFirestore.getDocs(query);
    //   if (!querySnapshot.empty) {
    //     querySnapshot.forEach((doc) => {
    //       const userRef = firebaseFirestore.doc(db, "users", doc.id);
    //       firebaseFirestore.updateDoc(userRef, {
    //         referralCount: firebaseFirestore.increment(1),
    //         referralList: firebaseFirestore.arrayUnion(generateRandomString())
    //       });
    //     });
    //   }
    //   await firebase_auth.signOut(auth);
    //   return res;
    // }
    await firebase_auth.signOut(auth);
    return res;
  } catch (error) {
    return error;
  }
}

export async function getCoupons(userName) {
  try {
    const docRef = firebaseFirestore.doc(db, "users", userName);
    const doc = await firebaseFirestore.getDoc(docRef);
    if (doc.exists()) {
      return doc.data().referralList;
    } else {
      console.log("No such document!");
      return null;
    }
  } catch (error) {
    console.log("Error getting document:", error);
    return null;
  }
}

export async function signout() {
  try {
    localStorage.clear();
    let res = await firebase_auth.signOut(auth);
    return res;
  } catch (error) {
    return error;
  }
}

export async function getCollection(collection_name) {
  try {
    let collection = firebaseFirestore.collection(db, collection_name);
    let res = await firebaseFirestore.getDocs(
      collection
    );
    res = res.docs.map((doc) => doc.data());
    return res;
  } catch (error) {
    return error;
  }
}

export async function placeOrder(order) {
  try {
    let query = firebaseFirestore.query(
      firebaseFirestore.collection(db, "orders"),
      firebaseFirestore.where("email", "==", order.email),
      firebaseFirestore.where("status", "==", 'pending')
    );
    const querySnapshot = await firebaseFirestore.getDocs(query);
    if (!querySnapshot.empty) {
      return 'Order already placed'
    }
    let res = await firebaseFirestore.addDoc(firebase_firestore.collection(db, "orders"), order);
    if (res.id) {
      return res
    }
  } catch (error) {
    return error;
  }
}

export async function forgotPassword(email) {
  try {
    let res = await firebase_auth.sendPasswordResetEmail(auth, email);
    return res;
  } catch (error) {
    return error;
  }
}

export async function getUser(email) {
  try {
    const docRef = firebase_firestore.doc(db, "users", email);
    const res = await firebase_firestore.getDoc(docRef);
    if (res.exists()) {
      return res.data();
    }
    // return res;
  } catch (error) {
    return error;
  }
}

export async function updateMessage(message, chat) {
  try {
    const docRef = firebase_firestore.doc(db, "chats", chat);
    const res = await firebase_firestore.updateDoc(docRef, {
      chats: firebase_firestore.arrayUnion(message),
    });
    return 'success'
  } catch (error) {
    return error;
  }
}